module.exports = __webpack_public_path__ + "static/img/neutrals_sm.bc63dbc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/demo-blog/neutrals_sm.jpg
// module id = pl15
// module chunks = 0